<div class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Text"
      [formField]="configForm.label" />
    <lib-signal-dropdown
      label="Style"
      [items]="dividerStyleOptions"
      valuePath="value"
      displayPath="label"
      [formField]="configForm.dividerStyle" />
    <lib-signal-dropdown
      label="Thickness"
      [items]="dividerThicknessOptions"
      valuePath="value"
      displayPath="label"
      [formField]="configForm.dividerThickness" />
    <lib-signal-color-field
      label="Color"
      [formField]="configForm.dividerColor" />
    <lib-signal-dropdown
      label="Opacity"
      [items]="dividerOpacityOptions"
      valuePath="value"
      displayPath="label"
      [formField]="configForm.dividerOpacity" />
  </section>
</div>
